import { render, staticRenderFns } from "./PosterTextLoader.vue?vue&type=template&id=2d21f294&scoped=true&"
import script from "./PosterTextLoader.vue?vue&type=script&lang=js&"
export * from "./PosterTextLoader.vue?vue&type=script&lang=js&"
import style0 from "./PosterTextLoader.vue?vue&type=style&index=0&id=2d21f294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21f294",
  null
  
)

export default component.exports